import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';

const NOT_RECEIVED = {
  color: '#9b59b6',
  label: <FormattedMessageWrapper id="Non reçu" />,
  reference: 'NOT_RECEIVED',
  value: 1,
};

const TO_CHECK = {
  color: '#964b00',
  label: <FormattedMessageWrapper id="A vérifier" />,
  reference: 'TO_CHECK',
  value: 2,
};

const PENDING_INFORMATIONS = {
  color: '#e67e22',
  label: <FormattedMessageWrapper id="En attente d'informations" />,
  reference: 'PENDING_INFORMATIONS',
  value: 3,
};

const CHECKED = {
  color: '#2ecc71',
  label: <FormattedMessageWrapper id="Validé" />,
  reference: 'CHECKED',
  value: 4,
};

const CHECKED_WITH_OPTION = {
  color: '#3498db',
  label: <FormattedMessageWrapper id="Vérifié avec dérogation" />,
  reference: 'CHECKED_WITH_OPTION',
  value: 5,
};

const REFUSED = {
  color: '#e74c3c',
  label: <FormattedMessageWrapper id="Refusé" />,
  reference: 'REFUSED',
  value: 6,
};

const statuses = {
  CHECKED,
  CHECKED_WITH_OPTION,
  NOT_RECEIVED,
  TO_CHECK,
  // eslint-disable-next-line sort-keys
  PENDING_INFORMATIONS,
  REFUSED,
};

export default statuses;

export const getStandDocumentStatusColor = (reference: string) => {
  return statuses[reference as keyof typeof statuses]?.color;
}

export const getStandDocumentStatusLabel = (reference: string) => {
  return statuses[reference as keyof typeof statuses]?.label;
}
